//  Sharedcount (Vanilla js version)
//  =============================================================
//  ie https://api.sharedcount.com/v1.0/?apikey=b9b9070064e6b4333bbb1db7af47c15772bf799c&url=https://www.brightlocal.com/2019/01/21/photos-in-google-local-services-ads-what-you-need-to-know/&callback=json

const shareCount = (url, element, fn) => {
    fn = new XMLHttpRequest;
    fn.open('GET', url, true);

    fn.onload = function () {
        if (this.response) {

            let grandTotal;
            let data = JSON.parse(this.response);

            let countTotals = data.Facebook.total_count
                + data.LinkedIn
                + data.GooglePlusOne
                + data.Pinterest
                + data.Twitter
                + data.StumbleUpon
                + data.Reddit;

            if (!element) {

                let initialCounts = document.querySelector('.share-count');
                let hardShares = initialCounts.dataset.count;

                if (countTotals === 0 || countTotals === null || countTotals === undefined) {
                    grandTotal = parseInt(hardShares);
                } else {
                    grandTotal = parseInt(hardShares) + parseInt(countTotals);
                }

                if (!isNaN(grandTotal)) {
                    initialCounts.innerText = grandTotal;
                } else {
                    initialCounts.innerText = parseInt(hardShares);
                }

                initialCounts.classList.add("active");
            }

            if (element) {
                postShareElement = element;
                postShareCount = element.dataset.count;

                if (countTotals === 0 || countTotals === null || countTotals === undefined) {
                    grandTotal = parseInt(postShareCount);
                } else {
                    grandTotal = parseInt(postShareCount) + parseInt(countTotals);
                }

                if (!isNaN(grandTotal)) {
                    postShareElement.innerText = grandTotal;
                } else {
                    postShareElement.innerText = parseInt(postShareCount);
                }

                postShareElement.classList.add("active");
            }

        } else {

            //  Just add the hard shares if anything goes wrong.
            if (!element) {

                initialCounts = document.querySelector('.share-count');
                hardShares = initialCounts.dataset.count;

                initialCounts.innerText = parseInt(hardShares);

                initialCounts.classList.add("active");
            }

            if (element) {

                postShareElement = element;
                postShareCount = element.dataset.count;

                postShareElement.innerText = parseInt(postShareCount);

                postShareElement.classList.add("active");
            }

        }
    };
    fn.send();
};

const getTeaserCount = () => {
    const domain = "//api.sharedcount.com/v1.0/";
    const apikey = "c8a4a67cb3f7edd9cce94b7689628643d42dda54";

    document.querySelectorAll('.loop-load-more .post .insight-post .post-meta .shares').forEach((element) => {
        if (element) {
            postShareElement = element.querySelector('.share-count');

            if (postShareElement) {
                fullUrl = postShareElement.dataset.url;
            }
            const parsedUrl = domain + '?apikey=' + apikey + '&url=' + fullUrl;

            shareCount(parsedUrl, postShareElement);
        }
    });
};

const getShares = () => {

    const siteDom = 'https://www.brightlocal.com';
    const path = window.location.pathname;
    const fullUrl = siteDom + path;
    const domain = "//api.sharedcount.com/v1.0/";
    const apikey = "c8a4a67cb3f7edd9cce94b7689628643d42dda54";
    const parsedUrl = domain + '?apikey=' + apikey + '&url=' + fullUrl;

    shareCount(parsedUrl, null);
};

export { getShares, getTeaserCount };